/** @jsx jsx */
import PropTypes from "prop-types"
import { jsx, Styled } from "theme-ui"

import Sparks from "components/svgs/sparks"

const StarBurst = ({ color, bg, left, as, children, className, sx }) => (
  <Styled.h1
    as={as}
    color={color}
    className={className}
    sx={{
      display: "inline-block",
      position: "relative",
      py: 0,
      px: left ? 5 : 0,
      pr: left ? 0 : 5,
      ...sx,
    }}
  >
    <Sparks
      sx={{
        bottom: 0,
        color: bg,
        height: "7rem",
        left: left ? 0 : "auto",
        right: left ? "auto" : 0,
        position: "absolute",
        top: 0,
        width: "auto",
        transform: left
          ? "scaleX(-1) rotate(-20deg) translateY(-30%) translateX(20%)"
          : "scaleX(1) rotate(10deg) translateY(-20%) translateX(-5%)",
      }}
    />
    {children}
  </Styled.h1>
)

StarBurst.defaultProps = {
  color: "text",
  bg: "primary",
  left: false,
  as: "h2",
}

StarBurst.propTypes = {
  color: PropTypes.string,
  bg: PropTypes.string,
  left: PropTypes.bool,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.any,
  className: PropTypes.string,
  sx: PropTypes.object,
}

export default StarBurst
